import { UseQueryResult } from 'react-query';
import { Bond } from '../../types/Bond';
import { Asset } from '../../types/Asset';
import { Portfolio } from '../../types/Portfolio';
import { Stock } from '../../types/Stock';
import React, { createContext } from 'react';
import { useGetFunds } from '../../api/funds-robot/getFunds';
import { useGetModelPortfolios } from '../../api/funds-robot/getModelPortfolios';

// interface FundsInterval {
//     type: IntervalType;
//     startDate?: DateTime;
//     endDate?: DateTime;
//     range: Interval;
// }

export type FundsSelectionContextProps = {
    modelPortfolios: {
        query: UseQueryResult<Portfolio[], unknown>;
    };
    funds: {
        query: UseQueryResult<(Stock | Bond)[], unknown>;
    };
    assets: {
        all: Asset[];
    };
};

export const FundsQueryContext = createContext<FundsSelectionContextProps>({
    modelPortfolios: {
        query: undefined!,
    },
    funds: {
        query: undefined!,
    },
    assets: {
        all: [],
    },
});

export const WithFundsQuery: React.FC<{children?: React.ReactNode}> = ({ children }) => {
    const fundsQuery = useGetFunds();
    const portfoliosQuery = useGetModelPortfolios();

    const assets = [...(fundsQuery.data || []), ...(portfoliosQuery.data || [])];

    return (
        <FundsQueryContext.Provider
            value={{
                modelPortfolios: {
                    query: portfoliosQuery,
                },
                funds: {
                    query: fundsQuery,
                },
                assets: {
                    all: assets,
                },
            }}
        >
            {children}
        </FundsQueryContext.Provider>
    );
};
